import { render, staticRenderFns } from "./DxEmployees.vue?vue&type=template&id=93d2e22e&scoped=true&"
import script from "./DxEmployees.vue?vue&type=script&lang=js&"
export * from "./DxEmployees.vue?vue&type=script&lang=js&"
import style0 from "./DxEmployees.vue?vue&type=style&index=0&id=93d2e22e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93d2e22e",
  null
  
)

export default component.exports